import { type Profile, profileSchema, type UpdateProfileInput } from '@noconflict/contracts';
import type { Supabase } from '../../shared/api/supabase';

/** The caller's own profile; null for a user who signed up without names. */
export async function getOwnProfile(client: Supabase, userId: string): Promise<Profile | null> {
  const { data, error } = await client
    .from('profiles')
    .select('*')
    .eq('user_id', userId)
    .maybeSingle();
  if (error) throw new Error(error.message);
  return data ? profileSchema.parse(data) : null;
}

/** Edits the caller's names (`update_profile` creates the profile when there is none). */
export async function updateProfile(client: Supabase, input: UpdateProfileInput): Promise<Profile> {
  const { data, error } = await client.rpc('update_profile', {
    p_first_name: input.firstName,
    p_last_name: input.lastName,
  });
  if (error) throw new Error(error.message);
  return profileSchema.parse(data);
}
